import { useEffect, useRef } from "react";
import style from "./BottomUi.module.scss";

const BottomUi = ({ isStop=true }) => {
    const telescopeHeadRef = useRef(null);

    useEffect(() => {
        if (isStop) {
            telescopeHeadRef.current.classList.add(style.stopped);
        } else {
            telescopeHeadRef.current.classList.remove(style.stopped);
        }
    }, [isStop]);

    return (
        <div className={style.tab2bottomUi}>
            <div className={style.bottomUi}>
                <img src='./grass.png' className={style.grass} />
                <img src='./BathWhale.png' className={style.BathWhale} />
                <img src='./cloud2.png' className={style.cloud2} />
                <img src='./cloud3.png' className={style.cloud3} />
            </div>
            <div className={style.box}>
                <img src='./Telescope.png' className={style.Telescope} />
                <img 
                    src='./Telescope_head.png' 
                    className={style.Telescope_head} 
                    ref={telescopeHeadRef} 
                />
            </div>
        </div>
    );
};

export default BottomUi;
